module.exports = __webpack_public_path__ + "img/recharge_transactions.2910ac73.svg";